<template>
	<Accordion
		:title="labels.title"
		:open="open"
		:disabled="disabled"
		:disabled-hint="disabledHint"
		:icon="icon"
		:icon-hint="iconHint"
		@toggle="$emit('toggle', $event)"
	>
		<div class="clip-name">
			<FormInput
				v-model="clipName"
				:disabled="disabled"
				:disabled-hint="disabledHint"
				:maxlength="MAX_LENGTH"
			>
				<template #trailing>
					<Icon
						icon-name="pen"
						size="md"
					/>
				</template>
			</FormInput>
			<div class="chars-counter">
				{{ nameLength }}/{{ MAX_LENGTH }}
			</div>
		</div>
		<MarkInOutButtons
			:clip-name="clipName"
		/>
	</Accordion>
</template>

<script>
import Accordion from '@components/accordion/Accordion';
import MarkInOutButtons from '@videotools/js/one/components/TagCenter/MarkInOutButtons';
import SectionLabelsMixin from '@videotools/js/one/components/TagGroups/mixin/SectionLabelsMixin';
import FormInput from '@videotools/js/one/components/Form/FormInput';
import { TAG_NAME_CUT } from '@videotools/js/api/entities/TagButton';
import { SECTION_MARKING_EVENT } from '@videotools/js/api/entities/TagGroup';
import transHelpers from '@videotools/js/util/transHelpers';

const MAX_LENGTH = 100;
const DEFAULT_CLIP_NAME = `${transHelpers.transTagLabel(TAG_NAME_CUT)}`;

export default {
	name:       'MarkInOutSection',
	components: { FormInput, Accordion, MarkInOutButtons },
	mixins:     [SectionLabelsMixin],
	props:      {
		title: {
			type: String,
		},
		open: {
			type:    Boolean,
			default: false,
		},
		disabled: {
			type:    Boolean,
			default: false,
		},
		disabledHint: {
			type:    String,
			default: null,
		},
		icon: {
			type: String,
		},
		iconHint: {
			type:     String,
			required: false,
		},
	},
	data() {
		return {
			clipName: DEFAULT_CLIP_NAME,
			MAX_LENGTH,
		};
	},
	computed: {
		labels() {
			return {
				title: this.transUcfirst(`tag_group.sections.team_sport.${SECTION_MARKING_EVENT}`),
			};
		},
		nameLength() {
			return this.clipName.length;
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import "@videotools/sass/_fonts.scss";

.clip-name {
	margin-bottom: 16px;
}

.chars-counter {
  margin-top: 6px;
  width: 100%;
  text-align: right;
  color: var(--color-grey-300);
  @include text-sm-2;
}
</style>
